import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { CountryService } from "../../core/service/country.service";
import { NetworkService } from "../../core/service/network.service";
import { Network } from "../../core/model/network";
import { Country } from "../../core/model/country";

@Component({
  selector: "app-edit-network",
  templateUrl: "./edit-network.component.html",
  styleUrls: ["./edit-network.component.scss"],
})
export class EditNetworkComponent implements OnInit {
  @Input()
  set network(value: Network) {
    if (value) {
      this._network = {
        ...value,
        country: value.country ? { ...value.country } : new Country(),
      };
      this.cdr.detectChanges();
    }
  }
  get network(): Network {
    return this._network;
  }

  private _network: Network;
  countries: Country[];

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = true;

  constructor(
    private _countryService: CountryService,
    private _networkService: NetworkService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      country: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getCountries();
  }

  getCountries() {
    this.loading = true;
    this._countryService.getAllCountries().subscribe(
      (data) => {
        this.countries = data;
        this.loading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        console.log(error);
        this.loading = false;
        this.cdr.detectChanges();
      }
    );
  }

  save(): void {
    this.pressButton = true;
    const selected = (this.countries || []).find(
      (c) => c.id === this.network.country.id
    );
    if (selected) {
      this.network.country = { ...selected };
    }

    this._networkService
      .putNetwork(this.network)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.network);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
